<template>
  <div class="w-100">
    <label
      v-if="itemModel.vars.label"
      :class="
        'form-label' +
        (itemModel.vars.label_attr && itemModel.vars.label_attr.class ? ' ' + itemModel.vars.label_attr.class : '') +
        (itemModel.vars.required ? ' required' : '')
      "
    >
      {{ index ? index + ". " : "" }}{{ itemModel.vars.label }}{{ itemModel.vars.required ? "*" : "" }}
      <span v-if="itemModel.vars.help && !isMobile()" v-tooltip="{ title: itemModel.vars.help, textWrap: true }">
        <FontAwesomeIcon icon="fa-light fa-circle-question" />
      </span>
    </label>
    <div v-if="isMobile() && itemModel.vars.help" class="form-info">
      <FontAwesomeIcon icon="fa-light fa-circle-question" />
      {{ itemModel.vars.help }}
    </div>
    <div v-if="!itemModel.vars.hide" class="d-flex">
      <Multiselect
        v-if="grouped"
        :id="itemModel.vars.id"
        v-model="itemModel.vars.value"
        :class="
          (itemModel.vars.isInvalid ? 'is-invalid' : '') +
          (itemModel.vars.attr && itemModel.vars.attr['data-taggable'] ? ' taggable' : '') +
          (itemModel.vars.attr && itemModel.vars.attr.class ? ' ' + itemModel.vars.attr.class : '')
        "
        :deselectGroupLabel="$t('multiselect.press_enter_remove_group')"
        :deselectLabel="$t('multiselect.press_enter_remove')"
        :disabled="itemModel.vars.disabled === true || itemModel.loading || isLoading"
        :group-select="isMultiple"
        :hideSelected="isMultiple"
        :internalSearch="!isAjaxSearch"
        :limit="10"
        :loading="isLoading || itemModel.loading"
        :multiple="isMultiple"
        :name="itemModel.vars.name"
        :options="choices"
        :placeholder="
          itemModel.vars.attr && itemModel.vars.attr.placeholder
            ? itemModel.vars.attr.placeholder
            : $t('multiselect.select_option')
        "
        :taggable="itemModel.vars.attr && itemModel.vars.attr['data-taggable']"
        :preserveSearch="true"
        :searchable="true"
        :selectGroupLabel="$t('multiselect.press_enter_group')"
        :selectLabel="$t('multiselect.press_enter')"
        :selectedLabel="$t('multiselect.selected')"
        :tagPlaceholder="$t('multiselect.press_enter_create_tag')"
        :allow-empty="!itemModel.vars.required || isMultiple"
        ref="multiselect"
        group-label="group"
        group-values="options"
        label="label"
        :style="itemModel.vars.attr && itemModel.vars.attr['style'] ? itemModel.vars.attr['style'] : ''"
        openDirection="bottom"
        class="position-relative"
        track-by="value"
        @close="close"
        @open="open"
        @remove="onRemove"
        @searchChange="searchAjaxDebounced"
        @select="onSelect"
        @tag="addTag"
      >
        <template v-slot:noOptions>
          <p>
            {{ isAjaxSearch ? $tc("multiselect.no_options", { nb: queryMinLength }) : $t("No data available") }}
          </p>
        </template>
        <template v-slot:noResult>
          <p>{{ $t("multiselect.no_result") }}</p>
        </template>
        <template v-slot:clear>
          <button
            v-if="
              hasValue &&
              !itemModel.vars.required &&
              !itemModel.vars.disabled &&
              !itemModel.vars?.attr?.['hide-select-refresh-button']
            "
            type="button"
            class="btn-icon position"
            @click="remove"
            v-tooltip="{ title: $t('remove') }"
          >
            <FontAwesomeIcon icon="fa-light fa-xmark" />
          </button>
        </template>
      </Multiselect>
      <Multiselect
        v-else
        :id="itemModel.vars.id"
        v-model="itemModel.vars.value"
        :class="
          (itemModel.vars.isInvalid ? 'is-invalid' : '') +
          (itemModel.vars.attr && itemModel.vars.attr['data-taggable'] ? ' taggable' : '') +
          (itemModel.vars.attr && itemModel.vars.attr.class ? ' ' + itemModel.vars.attr.class : '')
        "
        :deselectGroupLabel="$t('multiselect.press_enter_remove_group')"
        :deselectLabel="$t('multiselect.press_enter_remove')"
        :disabled="itemModel.vars.disabled === true"
        :hideSelected="isMultiple"
        :internalSearch="!isAjaxSearch"
        :limit="10"
        :loading="isLoading || itemModel.loading"
        :multiple="isMultiple"
        :name="itemModel.vars.name"
        :options="choices"
        :placeholder="
          itemModel.vars.attr && itemModel.vars.attr.placeholder
            ? itemModel.vars.attr.placeholder
            : $t('multiselect.select_option')
        "
        :taggable="itemModel.vars.attr && itemModel.vars.attr['data-taggable']"
        :preserveSearch="true"
        :searchable="true"
        :selectGroupLabel="$t('multiselect.press_enter_group')"
        :selectLabel="$t('multiselect.press_enter')"
        :selectedLabel="$t('multiselect.selected')"
        :tagPlaceholder="$t('multiselect.press_enter_create_tag')"
        :allow-empty="!itemModel.vars.required || isMultiple"
        ref="multiselect"
        label="label"
        openDirection="bottom"
        track-by="value"
        class="position-relative"
        :style="itemModel.vars.attr && itemModel.vars.attr['style'] ? itemModel.vars.attr['style'] : ''"
        @close="close"
        @open="open"
        @remove="onRemove"
        @searchChange="searchAjaxDebounced"
        @select="onSelect"
        @tag="addTag"
      >
        <template v-slot:noOptions>
          <p>
            {{ isAjaxSearch ? $tc("multiselect.no_options", { nb: queryMinLength }) : $t("No data available") }}
          </p>
        </template>
        <template v-slot:noResult>
          <p>{{ $t("multiselect.no_result") }}</p>
        </template>
        <template v-slot:clear>
          <button
            v-if="
              hasValue &&
              !itemModel.vars.required &&
              !itemModel.vars.disabled &&
              !itemModel.vars?.attr?.['hide-select-refresh-button']
            "
            type="button"
            class="btn-icon position"
            @click="remove"
            v-tooltip="{ title: $t('remove') }"
          >
            <FontAwesomeIcon icon="fa-light fa-xmark" />
          </button>
        </template>
      </Multiselect>
      <button
        v-if="itemModel.vars.attr['data-button-attr']?.dataUrl"
        v-tooltip="{
          title: itemModel.vars.attr['data-button-attr']?.buttonTooltip
            ? itemModel.vars.attr['data-button-attr'].buttonTooltip
            : $t('multiselect.press_enter_create_tag'),
        }"
        type="button"
        :disabled="itemModel.vars.disabled"
        class="btn btn-success ms-2 selectBtn"
        @click="action"
      >
        <FontAwesomeIcon
          :icon="
            'fa-light fa-' +
            (itemModel.vars.attr['data-button-attr']?.icon ? itemModel.vars.attr['data-button-attr'].icon : 'plus')
          "
        />
        {{
          itemModel.vars.attr["data-button-attr"]?.buttonText ? itemModel.vars.attr["data-button-attr"].buttonText : ""
        }}
      </button>
    </div>
    <div ref="backdrop" class="modal-backdrop fade"></div>
    <div
      v-if="
        itemModel.vars.error &&
        (!itemModel.vars.attr || (itemModel.vars.attr && !itemModel.vars.attr['data-hide-error']))
      "
      class="invalid-feedback d-block"
    >
      {{ itemModel.vars.error }}
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "@suadelabs/vue3-multiselect/dist/vue3-multiselect.css";
import { formValidator } from "@/services/form/form-validator";
import { toRaw } from "vue";
import { apiConnection } from "@/services/api-connection";
import { mapState } from "pinia";
import { formManager } from "@/services/form/form-manager";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useFormStore } from "@/store/form/form";

export default {
  name: "SelectTypeComponent",
  components: {
    FontAwesomeIcon,
    Multiselect,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: null,
    },
    templatedSelection: {
      type: Boolean,
      required: false,
      default: false,
    },
    ignoreBwIgnore: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["update", "toggle", "draft", "focus", "selected", "ajaxTargetLoad", "resetInputs", "selectTypeAction"],
  data() {
    return {
      itemModel: this.model,
      choices: [],
      isLoading: false,
      queryMinLength: 2,
      queryMaxLength: 255,
      queryType: null,
      searchAjaxDebounced: null,
      initialized: false,
    };
  },

  computed: {
    ...mapState(useFormStore, {
      parentAjaxParamsCorrespondingTable: (store) => store.parentAjaxParamsCorrespondingTable,
    }),
    isMultiple() {
      return formManager.isMultiple(this.itemModel);
    },
    isAjaxSearch() {
      return !!formManager.isAjaxSearch(this.itemModel);
    },
    isAjaxLoad() {
      return !!formManager.isAjaxLoad(this.itemModel);
    },
    isEntity() {
      return formManager.isEntityType(this.itemModel);
    },
    grouped() {
      return this.choices.some((c) => c.group !== undefined);
    },
    hasValue() {
      const v = this.itemModel.vars.value;
      if (!v) return false;
      if (Array.isArray(v)) return v.length > 0;
      if (typeof v === "object") return Object.keys(v).length > 0;
      return true;
    },
  },

  watch: {
    "model.vars.choices": {
      handler() {
        this.processChoices();
        this.syncSelected();
        if (this.isMultiple) {
          this.emitUpdate();
        }
      },
    },
    "model.vars.value"() {
      if (this.itemModel.vars.toggler_target) {
        this.$emit("toggle", this.itemModel);
      }
    },
    "model.vars.error"() {
      this.updateValidState();
    },
    model() {
      this.itemModel = this.model;
    },
  },

  mounted() {
    if (!this.ignoreBwIgnore) {
      const input = document.querySelector(`input[name='${this.itemModel.vars.name}']`);
      if (input) {
        input.setAttribute("data-bwignore", "true");
      }
    }
    this.searchAjaxDebounced = this.debounce(this.searchAjax, 500);
    this.processChoices(true);
    this.syncSelected(true);
    this.setQueryMinMaxLength();
  },

  beforeUnmount() {
    const body = document.getElementById("body");
    body?.classList.remove("modal-multiselect");
  },

  methods: {
    isMobile() {
      return window.innerWidth < 992;
    },

    processChoices(init = false) {
      let choices = this.itemModel.vars.choices;

      if (this.isEntity && choices && Object.keys(choices).length) {
        choices = Object.values(choices);
      }

      if (this.isEntity && this.isMultiple && this.itemModel.vars.data?.length && choices?.length && init) {
        this.itemModel.vars.value = choices.filter((choice) =>
          this.itemModel.vars.data.some((data) => data.id === choice.data.id),
        );
      }

      if (choices?.length) {
        const grouped = [];
        let hasGroups = false;

        choices.forEach((choice) => {
          if (choice.choices && Object.keys(choice.choices).length) {
            grouped.push({
              group: choice.label,
              options: Object.values(toRaw(choice.choices)),
            });
            hasGroups = true;
          }
        });

        this.choices = hasGroups ? grouped : choices;
      } else if (this.isEntity && !this.isMultiple && this.itemModel.vars.data?.id) {
        let name = this.itemModel.vars.data.name;
        if (this.itemModel.vars.data.postCode) {
          name += ` (${this.itemModel.vars.data.postCode})`;
        }
        this.choices = [
          {
            label: name,
            value: this.itemModel.vars.data.id.toString(),
            data: this.itemModel.vars.data.id,
          },
        ];
      } else {
        this.choices = [];
      }
    },

    syncSelected(init = false) {
      if (this.itemModel.vars.attr?.["data-taggable"]) {
        if (init && this.itemModel.vars.data?.length) {
          const initialTags = this.itemModel.vars.data.map((tag) => ({
            label: tag,
            value: tag,
            data: tag,
          }));
          this.itemModel.vars.value = initialTags;
        }
        return;
      }

      if (init && this.isMultiple && this.itemModel.vars.data) {
        if (!this.isEntity) {
          this.itemModel.vars.value = this.choices.filter((choice) => this.itemModel.vars.data.includes(choice.data));
        }
        return;
      }

      if (!this.choices.length) return;

      const rawValue = this.resolveRawValue(init);
      if (!(rawValue || typeof rawValue === "number")) return;

      const selected = this.findMatchingChoices(rawValue, init);
      if (selected && (!Array.isArray(selected) || selected.length > 0)) {
        this.itemModel.vars.value = selected;
      }
    },

    resolveRawValue(init) {
      if (this.isMultiple) {
        if (init && this.itemModel.vars.data?.length && this.isEntity) {
          return this.itemModel.vars.data;
        }
        return this.itemModel.vars.value;
      }

      if (this.isEntity) {
        let value =
          this.itemModel.vars.value && typeof this.itemModel.vars.value === "object"
            ? this.itemModel.vars.value.value
            : this.itemModel.vars.value;
        if (!value && this.itemModel.vars.data?.id) {
          value = this.itemModel.vars.data.id;
        }
        return value;
      }

      return this.itemModel.vars.value;
    },

    findMatchingChoices(value, init) {
      const modelChoices = Object.values(this.itemModel.vars.choices || {});
      const hasGroups = modelChoices.some((c) => c.choices);

      if (hasGroups) {
        return this.findInGroupedChoices(modelChoices, value);
      }

      if (this.isMultiple) {
        return this.findMultipleInFlat(value, init);
      }

      return Object.values(this.choices).find((item) => item.value?.toString() === value?.toString()) || null;
    },

    findInGroupedChoices(groupedChoices, value) {
      if (this.isMultiple && typeof value === "object") {
        let selected = [];
        groupedChoices.forEach((group) => {
          if (group.choices) {
            Object.values(value).forEach((val) => {
              selected = selected.concat(Object.values(group.choices).filter((item) => item.value === val.value));
            });
          }
        });
        return selected;
      }

      for (const group of groupedChoices) {
        if (group.choices) {
          const found = Object.values(group.choices).find((item) => value && item.value === value.toString());
          if (found) return found;
        }
      }
      return null;
    },

    findMultipleInFlat(value, init) {
      if (init && this.isEntity) {
        if (!Array.isArray(value)) {
          return Object.values(this.choices).filter((item) => value.includes(item.value));
        }
        const selected = [];
        value.forEach((data) => {
          if (data.id) {
            const item = (this.itemModel.vars.choices || []).find((choice) => choice.data?.id === data.id);
            if (item) selected.push(item);
          }
        });
        return selected;
      }

      if (typeof value === "object") {
        return Object.values(this.choices).filter((item) => {
          if (this.isEntity && value.length && value[0]?.id) {
            const ids = Array.from(value, (obj) => obj.id);
            return ids.includes(item.data?.id);
          }
          return value.includes(item);
        });
      }

      return [];
    },

    updateValidState() {
      if (this.itemModel.vars.required && (!this.itemModel.vars.value || this.itemModel.vars.value === "")) {
        this.itemModel.vars.isInvalid = true;
      } else if (this.itemModel.vars.required) {
        this.itemModel.vars.isInvalid = false;
      }
    },

    emitUpdate() {
      const value = this.itemModel.vars.value;
      this.$emit("update", value && Object.keys(value).length ? value.value : "");
    },

    onSelect() {
      if (!this.itemModel.vars.attr?.["data-taggable"]) {
        this.emitUpdate();
      }

      if (this.itemModel.vars.toggler_target) {
        this.$emit("toggle", this.itemModel);
      }
      formValidator.validModel(this.itemModel);
      this.updateValidState();
      if (this.isAjaxLoad && this.itemModel.vars.value?.data) {
        formManager.fieldLoad(this.itemModel, this);
        if (Object.keys(this.itemModel.vars.attr["data-ajax-load"]).length) {
          this.$emit("resetInputs", {
            item: this.itemModel.vars.attr["data-ajax-load"],
          });
        }
      }
      this.$emit("draft", this.itemModel);
    },

    onRemove() {
      if (!this.itemModel.vars.attr?.["data-taggable"]) {
        this.emitUpdate();
      }

      if (this.itemModel.vars.toggler_target) {
        this.$emit("toggle", this.itemModel);
      }
      formValidator.validModel(this.itemModel);
      this.updateValidState();
      this.$emit("draft", this.itemModel);
    },

    remove() {
      this.itemModel.vars.value = this.isMultiple ? [] : null;
      this.emitUpdate();
      formValidator.validModel(this.itemModel);
      this.updateValidState();
      this.$emit("resetInputs", {
        item: this.itemModel.vars.attr["data-ajax-load"],
      });
      this.$emit("draft", this.itemModel);
    },

    setQueryMinMaxLength() {
      const attr = this.itemModel.vars?.attr;
      if (attr?.["data-ajax-query-min-length"]) {
        this.queryMinLength = attr["data-ajax-query-min-length"];
      }
      if (attr?.["data-ajax-query-max-length"]) {
        this.queryMaxLength = attr["data-ajax-query-max-length"];
      }
      if (attr?.["data-ajax-query-type"]) {
        this.queryType = attr["data-ajax-query-type"];
      }
    },

    debounce(fn, delay = 300) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },

    processQuery(query) {
      if (this.queryType) {
        switch (this.queryType) {
          case "integer":
            query = query.replace(/\D/g, "");
            break;
        }
        this.$refs.multiselect.updateSearch(query);
      }
      return query;
    },

    searchAjax(query = "") {
      query = this.processQuery(query);

      if (this.isAjaxLoad && !query && this.itemModel.vars.value?.data) {
        formManager.fieldLoad(this.itemModel, this);
        if (Object.keys(this.itemModel.vars.attr["data-ajax-load"]).length) {
          this.$emit("resetInputs", {
            item: this.itemModel.vars.attr["data-ajax-load"],
          });
        }
      } else if (this.isAjaxSearch && query) {
        if (query.length >= this.queryMinLength && query.length <= this.queryMaxLength && !this.isLoading) {
          this.isLoading = true;
          const url = this.itemModel.vars.attr["data-ajax-url"] + "/" + query;

          let queryParams = this.setQueryParamsFromRoute();
          queryParams = this.setQueryParamsFromParent(queryParams);

          apiConnection.get(url, queryParams).then((data) => {
            // Setting choices triggers the watcher which handles processChoices + syncSelected
            this.itemModel.vars.choices = { ...data };
            this.isLoading = false;
            if (this.itemModel.vars.attr?.["data-ajax-auto-select"]) {
              this.$nextTick(() => {
                if (this.choices.length) {
                  this.itemModel.vars.value = this.choices[0];
                }
              });
            }
          });
        }
      }
    },

    setQueryParamsFromRoute() {
      const queryParams = {};
      if (this.itemModel.vars.attr["data-ajax-url-params"]?.length) {
        this.itemModel.vars.attr["data-ajax-url-params"].forEach((param) => {
          queryParams[param] = this.$route.params[param];
        });
      }
      return queryParams;
    },

    setQueryParamsFromParent(queryParams) {
      if (this.parentAjaxParamsCorrespondingTable && Object.keys(this.parentAjaxParamsCorrespondingTable).length) {
        Object.entries(this.parentAjaxParamsCorrespondingTable).forEach(([field, value]) => {
          if (this.itemModel.vars.name === field) {
            queryParams = { ...queryParams, ...value };
          }
        });
      }
      return queryParams;
    },

    open() {
      this.$emit("focus");
      if (this.isMobile()) {
        this.$refs.backdrop?.classList.add("show");
        document.getElementById("body")?.classList.add("modal-multiselect");
      }
    },

    close() {
      if (this.isMobile()) {
        this.$refs.backdrop?.classList.remove("show");
        document.getElementById("body")?.classList.remove("modal-multiselect");
      }
      this.$emit("selected", this.itemModel);
    },

    addTag(newTag) {
      const newOption = {
        label: newTag,
        value: newTag,
        data: newTag,
      };

      this.choices = [...this.choices, newOption];
      this.itemModel.vars.value = [...(this.itemModel.vars.value || []), newOption];
      formValidator.validModel(this.itemModel);
      this.$emit("draft", this.itemModel);
    },

    action() {
      if (this.itemModel.vars.attr?.["data-button-attr"]) {
        this.$emit("selectTypeAction", { button: this.itemModel.vars.attr["data-button-attr"], model: this.itemModel });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.non-empty {
  overflow: auto;
}

.modal-backdrop {
  visibility: hidden;
  z-index: 10;

  &.show {
    visibility: visible;
  }
}

.position {
  position: absolute;
  top: 9px;
  right: 30px;
  z-index: 1;
  color: red;

  @include dark-theme {
    color: $white;
  }
}

.selectBtn {
  flex: 0 0 40px;
}
</style>
